/** Runtime default follows the app/admin + api subdomains used by Caddy.
 * An explicit build override still supports other hosting layouts. */
export function browserApiOrigin(configured: string | undefined, pageOrigin: string): string {
  const override = configured?.trim();
  if (override) return override.replace(/\/$/, '');
  // Keep this shared helper independent of DOM/Node globals.
  const parts = /^(https?:)\/\/(\[[^\]]+\]|[^:/]+)(:\d+)?$/.exec(pageOrigin);
  if (!parts) return pageOrigin;
  const [, protocol, hostname = '', port = ''] = parts;
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]') {
    return `${protocol}//${hostname}:4000`;
  }
  if (/^(app|admin)\./.test(hostname)) {
    return `${protocol}//${hostname.replace(/^(app|admin)\./, 'api.')}${port}`;
  }
  return pageOrigin;
}
